var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"app-error"},[_vm._v("App source is not available...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }